import ImportantDates from './ImportantDates';
import Specification from './Specification';
import Sales from './Sales';
import Progress from './Progress';

export default {
  components: {
    ImportantDates,
    Specification,
    Sales,
    Progress
  }
};
